import React from 'react';
import { useTranslation } from 'react-i18next';
//api
import { 
  getTermsOfUse, 
  createTermsOfUse, 
  updateTermsOfUse 
} from 'api/company';
//components
import LegalForm from './legalForm';

const TermsForm = () => {
  const { t } = useTranslation(['footer']);

  return (
    <LegalForm
      fetchApi={getTermsOfUse}
      createApi={createTermsOfUse}
      updateApi={updateTermsOfUse}
      titleKey="title"
      textKey="text"
      title={t('aceptarPoliticasTres')}
      dataTestId="terms-use"
    />
  );
};

export default TermsForm;
